import { createContext } from 'react';
import type { Tenant } from '../../domain/entities/tenant.entity';

export const TenantContext = createContext<Tenant | null>(null);
